import Icon from '../icon';
import {addStyle, isTextBlock, getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    type, name, value, placeholder, tabindex,
    readonly, clearable, disabled, size, nativeProps,
    rows, spellcheck, defaultValue, style, _width,
    className, autoWidth, fluid, width, autocomplete,
    stackClearIcon, frozenOnInput, _inputing, _originalValue
} = self.get();

const inputValue = frozenOnInput && _inputing ? _originalValue : value;

const classNameObj = {
    'k-input': true,
    [`k-${size}`]: size !== 'default',
    'k-group': blocks.prepend || blocks.append,
    'k-disabled': disabled,
    'k-with-prefix': blocks.prefix,
    'k-with-suffix': blocks.suffix,
    'k-clearable': clearable,
    'k-auto-width': autoWidth,
    'k-fluid': fluid,
    'k-stack-clear': stackClearIcon,
    [className]: className,
}

const events = [
    'keydown', 'keyup', 'change',
    'keypress', /* 'focus', 'blur', */ /* 'input' */
].reduce((memo, name) => {
    memo[`ev-${name}`] = self._proxyEvent.bind(self, name);
    return memo;
}, {});

const wrapperEvents = [
    'click', 'mouseenter', 'mouseleave'
].reduce((memo, name) => {
    memo[`ev-${name}`] = self._proxyEvent.bind(self, name);
    return memo;
}, {});

    return h('div', {
        'style': function() {try {return (width != null ? addStyle(style, {width: `${width}px`}) : style )} catch(e) {_e(e)}}.call($this),
        ...function() {try {return (wrapperEvents )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (do {
        if (blocks.prepend) {
            // if the children of this block is text node
            // we add a padding to the wrapper node
            // so we handle this block manually
            const children = blocks.prepend.call(this, () => {});
            h('div', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                "k-prepend": true, 
                "k-padding": isTextBlock(children)
            } )} catch(e) {_e(e)}}.call($this)))
        }
    } )} catch(e) {_e(e)}}.call($this),
        h('div', null, [
            function() {try {return (blocks.prefix )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, (_blocks['prefix'] = function(parent) {
                    return null;
                }) && (__blocks['prefix'] = function(parent) {
                    var args = arguments;
                    return blocks['prefix'] ? blocks['prefix'].apply($this, [function() {
                        return _blocks['prefix'].apply($this, args);
                    }].concat(__slice.call(args, 1))) : _blocks['prefix'].apply($this, args);
                }) && __blocks['prefix'].apply($this, [__noop]), 'k-prefix') :
                undefined,
            function() {try {return (type !== 'textarea' )} catch(e) {_e(e)}}.call($this) ?
                h('input', {
                    ...function() {try {return ((nativeProps || {}) )} catch(e) {_e(e)}}.call($this),
                    'type': function() {try {return (type )} catch(e) {_e(e)}}.call($this),
                    'name': function() {try {return (name )} catch(e) {_e(e)}}.call($this),
                    'value': function() {try {return (inputValue )} catch(e) {_e(e)}}.call($this),
                    'defaultValue': function() {try {return (defaultValue )} catch(e) {_e(e)}}.call($this),
                    'readOnly': function() {try {return (readonly )} catch(e) {_e(e)}}.call($this),
                    'placeholder': function() {try {return (placeholder )} catch(e) {_e(e)}}.call($this),
                    'disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
                    'tabindex': function() {try {return (tabindex )} catch(e) {_e(e)}}.call($this),
                    'autocomplete': function() {try {return (autocomplete )} catch(e) {_e(e)}}.call($this),
                    ...function() {try {return (events )} catch(e) {_e(e)}}.call($this),
                    'style': function() {try {return (autoWidth ? {width: _width + 'px'} : undefined )} catch(e) {_e(e)}}.call($this),
                    'ev-focus': function() {try {return (self._startInput )} catch(e) {_e(e)}}.call($this),
                    'ev-blur': function() {try {return (self._endInput )} catch(e) {_e(e)}}.call($this),
                    'ev-input': function() {try {return (self._onInput )} catch(e) {_e(e)}}.call($this)
                }, null, 'k-inner', null, function(i) {widgets['input'] = i}) :
                h('textarea', {
                    ...function() {try {return ((nativeProps || {}) )} catch(e) {_e(e)}}.call($this),
                    'value': function() {try {return (inputValue )} catch(e) {_e(e)}}.call($this),
                    'defaultValue': function() {try {return (defaultValue )} catch(e) {_e(e)}}.call($this),
                    'name': function() {try {return (name )} catch(e) {_e(e)}}.call($this),
                    'readOnly': function() {try {return (readonly )} catch(e) {_e(e)}}.call($this),
                    'placeholder': function() {try {return (placeholder )} catch(e) {_e(e)}}.call($this),
                    'disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
                    'rows': function() {try {return (rows )} catch(e) {_e(e)}}.call($this),
                    'spellcheck': function() {try {return (spellcheck )} catch(e) {_e(e)}}.call($this),
                    'tabindex': function() {try {return (tabindex )} catch(e) {_e(e)}}.call($this),
                    ...function() {try {return (events )} catch(e) {_e(e)}}.call($this),
                    'ev-focus': function() {try {return (self._startInput )} catch(e) {_e(e)}}.call($this),
                    'ev-blur': function() {try {return (self._endInput )} catch(e) {_e(e)}}.call($this),
                    'ev-input': function() {try {return (self._onInput )} catch(e) {_e(e)}}.call($this)
                }, null, 'k-inner k-textarea', null, function(i) {widgets['input'] = i}),
            function() {try {return (blocks.suffix || clearable && !disabled )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, [
                    function() {try {return (clearable && !disabled )} catch(e) {_e(e)}}.call($this) ?
                        h(Icon, {
                            'className': _className(function() {try {return ({
                    "k-clear ion-ios-close": true, 
                    "k-show": value,
                } )} catch(e) {_e(e)}}.call($this)),
                            '_context': $this,
                            'ev-click': function() {try {return (self.clear )} catch(e) {_e(e)}}.call($this)
                        }) :
                        undefined,
                    function() {try {return (' ' )} catch(e) {_e(e)}}.call($this),
                    (_blocks['suffix'] = function(parent) {
                        return null;
                    }) && (__blocks['suffix'] = function(parent) {
                        var args = arguments;
                        return blocks['suffix'] ? blocks['suffix'].apply($this, [function() {
                            return _blocks['suffix'].apply($this, args);
                        }].concat(__slice.call(args, 1))) : _blocks['suffix'].apply($this, args);
                    }) && __blocks['suffix'].apply($this, [__noop])
                ], 'k-suffix') :
                undefined,
            function() {try {return (autoWidth )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, function() {try {return (value == null || value === '' ? placeholder : value )} catch(e) {_e(e)}}.call($this), 'k-fake', null, function(i) {widgets['fake'] = i}) :
                undefined
        ], 'k-wrapper'),
        function() {try {return (do {
        if (blocks.append) {
            const children = blocks.append.call(this, () => {});
            h('div', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                "k-append": true, 
                "k-padding": isTextBlock(children)
            } )} catch(e) {_e(e)}}.call($this)))
        }
    } )} catch(e) {_e(e)}}.call($this)
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}